module.exports = "\r\n<button mat-button [ngClass]=\"class\" [type]=\"type\" routerLink=\"routerLink\" (click)=\"onClickEvent.emit($event)\" [disabled]=\"disabled\">{{text}}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/button.control.html
// module id = ../../../../../client/app/shared/controls/button.control.html
// module chunks = main